import { useState } from "react";
import Box from "@mui/material/Box";
import { Button, Form } from "react-bootstrap";
import NavBar from "../../structure/NavBar";
import { NavBarTop } from "../../structure/NavBarTop";
import InsufficientPermission from "../../custom/InSufficientPermission";
import { useSelector, useDispatch } from "react-redux";
import { updateLoading } from "../../../redux/features/common/commonSlice";
import { showDangerToast, showToast } from "../../constants/toaster";
import ShowLongText from "../../custom/ShowLongText";
import NoDataImg from "../../../assets/img/no-data.gif";

const SearchOtp = () => {
    const dispatch = useDispatch();
    const LOADING_ENABLE = useSelector((state) => state?.loading);
    const userPermissions = useSelector((state) => state?.permission);
    const moduleId = 57; // Adjust based on your module ID mapping

    let viewPermission = true;

    if (userPermissions?.modules?.length > 0) {
        const currentModulePermission = userPermissions.modules.find(
            (element) => element.moduleId === '57'
        )?.permissions;

        if (currentModulePermission) {
            viewPermission = currentModulePermission.find(
                (element) => element.name === 'VIEW'
            )?.isEnable;
        }
    }

    const [phoneNumber, setPhoneNumber] = useState("");
    const [otpData, setOtpData] = useState([]);
    const [searched, setSearched] = useState(false);

    const handleSearch = async () => {
        if (!phoneNumber.trim()) {
            showDangerToast("Please enter a phone number");
            return;
        }

        try {
            dispatch(updateLoading(true));
            setSearched(true);

            const response = await fetch(
                `https://7qcesydird.execute-api.af-south-1.amazonaws.com/default/ReadOtpDynamo?phone=${encodeURIComponent(phoneNumber)}`
            );

            if (!response.ok) {
                throw new Error("Failed to fetch OTP data");
            }

            const data = await response.json();

            if (Array.isArray(data)) {
                setOtpData(data);
                if (data.length === 0) {
                    showToast("No OTP records found for this phone number");
                } else {
                    showToast(`Found ${data.length} OTP record(s)`);
                }
            } else {
                setOtpData([]);
                showDangerToast("Invalid response format");
            }
        } catch (error) {
            console.error("Error fetching OTP data:", error);
            showDangerToast(error.message || "Error fetching OTP data");
            setOtpData([]);
        } finally {
            dispatch(updateLoading(false));
        }
    };

    const handleReset = () => {
        setPhoneNumber("");
        setOtpData([]);
        setSearched(false);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            return new Date(dateString).toLocaleString();
        } catch {
            return dateString;
        }
    };

    const extractOTP = (rawPayload) => {
        if (!rawPayload) return "N/A";
        try {
            const payload = JSON.parse(rawPayload);
            return payload.otp || "N/A";
        } catch {
            return "N/A";
        }
    };

    return (
        <div>
            <NavBar />
            <div className="main-content">
                <NavBarTop />
                <div className="header">
                    <div className="logo">
                        <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8"></div>
                    </div>
                </div>
                <div className="container-fluid mt--7">
                    <div className="row">
                        <div className="col text-left">
                            <div className="card shadow">
                                <div className="card-header border-0">
                                    <div className="row align-items-center text-left">
                                        <div className="col">
                                            <h3 className="mb-0">Service Manager</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    {viewPermission ? (
                                        <div className="card-body">
                                            <h3 className="mb-4">Search OTP by Phone Number</h3>
                                            <div className="row mb-4">
                                                <div className="col-md-6">
                                                    <Form.Group>
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter phone number (e.g., +918209378662)"
                                                            value={phoneNumber}
                                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                                            onKeyPress={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    handleSearch();
                                                                }
                                                            }}
                                                            disabled={LOADING_ENABLE}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6 d-flex align-items-end">
                                                    <Button
                                                        variant="primary"
                                                        onClick={handleSearch}
                                                        disabled={LOADING_ENABLE}
                                                        className="mr-2"
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        onClick={handleReset}
                                                        disabled={LOADING_ENABLE}
                                                    >
                                                        Reset
                                                    </Button>
                                                </div>
                                            </div>

                                            {searched && (
                                                <>
                                                    {otpData.length > 0 ? (
                                                        <div className="table-responsive">
                                                            <table className="table align-items-center table-flush">
                                                                <thead className="thead-light">
                                                                    <tr>
                                                                        <th scope="col">Phone</th>
                                                                        <th scope="col">Status</th>
                                                                        <th scope="col">Created At</th>
                                                                        <th scope="col">OTP</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {otpData.map((record, index) => (
                                                                        <tr key={index}>
                                                                            <td>{record.phone || "N/A"}</td>
                                                                            <td>
                                                                                <span
                                                                                    className={`badge badge-${record.status === "SENT"
                                                                                        ? "success"
                                                                                        : record.status === "LOCKED"
                                                                                            ? "warning"
                                                                                            : "secondary"
                                                                                        }`}
                                                                                >
                                                                                    {record.status || "N/A"}
                                                                                </span>
                                                                            </td>
                                                                            <td>{formatDate(record.created_at)}</td>
                                                                            <td>
                                                                                <strong className="text-primary">
                                                                                    {extractOTP(record.raw_payload)}
                                                                                </strong>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-5">
                                                            <img
                                                                src={NoDataImg}
                                                                alt="No Data"
                                                                width="25%"
                                                            />
                                                            <p className="mt-3 text-muted">
                                                                No OTP records found for this phone number
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <InsufficientPermission />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchOtp;
